import classNames from 'classnames';
import PropTypes from 'prop-types';

const ImageTile = ({
  altText = '',
  image,
  isCollectionCategoryList = false,
  isHover = false,
  isTileGrid,
  name,
  preventLazyLoad,
  rendered = false,
  renderImage,
  theme,
}) => {
  if (!rendered) return null;
  const imageTagClasses = [
    theme.image,
    isCollectionCategoryList && theme.categoryListImage,
    isTileGrid ? theme.gridImage : null,
  ];
  const tileImage = renderImage({
    alt: altText || name,
    className: classNames(imageTagClasses),
    dataTest: 'tile-image',
    isHover,
    preventLazyLoad,
    style: {
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0))',
    },
    src: image,
  });
  return tileImage;
};

ImageTile.propTypes = {
  altText: PropTypes.string,
  image: PropTypes.string.isRequired,
  isHover: PropTypes.bool,
  name: PropTypes.string,
  preventLazyLoad: PropTypes.bool,
  rendered: PropTypes.bool.isRequired,
  renderImage: PropTypes.func.isRequired,
  theme: PropTypes.shape({}),
};
export default ImageTile;
